import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=2e3e6f20&scoped=true&"
import script from "./Risk.vue?vue&type=script&lang=ts&"
export * from "./Risk.vue?vue&type=script&lang=ts&"
import style0 from "./Risk.vue?vue&type=style&index=0&id=2e3e6f20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3e6f20",
  null
  
)

export default component.exports